export const countries = [
  { name: 'United States', code: '+1', flag: '🇺🇸' },
  { name: 'United Kingdom', code: '+44', flag: '🇬🇧' },
  { name: 'Canada', code: '+1', flag: '🇨🇦' },
  { name: 'Australia', code: '+61', flag: '🇦🇺' },
  { name: 'Germany', code: '+49', flag: '🇩🇪' },
  { name: 'France', code: '+33', flag: '🇫🇷' },
  { name: 'Italy', code: '+39', flag: '🇮🇹' },
  { name: 'Spain', code: '+34', flag: '🇪🇸' },
  { name: 'Netherlands', code: '+31', flag: '🇳🇱' },
  { name: 'Belgium', code: '+32', flag: '🇧🇪' },
  { name: 'Switzerland', code: '+41', flag: '🇨🇭' },
  { name: 'Austria', code: '+43', flag: '🇦🇹' },
  { name: 'Poland', code: '+48', flag: '🇵🇱' },
  { name: 'India', code: '+91', flag: '🇮🇳' },
  { name: 'China', code: '+86', flag: '🇨🇳' },
  { name: 'Japan', code: '+81', flag: '🇯🇵' },
  { name: 'South Korea', code: '+82', flag: '🇰🇷' },
  { name: 'Singapore', code: '+65', flag: '🇸🇬' },
  { name: 'United Arab Emirates', code: '+971', flag: '🇦🇪' },
  { name: 'Brazil', code: '+55', flag: '🇧🇷' },
  { name: 'Mexico', code: '+52', flag: '🇲🇽' },
  { name: 'South Africa', code: '+27', flag: '🇿🇦' }
];

export const teamMembers = [
  {
    name: 'Kamila Kairys',
    role: 'Recovery Specialist',
    image: '/img/team/member-01.jpg'
  },
  {
    name: 'Alicja Gross',
    role: 'Legal Expert',
    image: '/img/team/member-02.jpg'
  },
  {
    name: 'Marta Dunat',
    role: 'Financial Analyst',
    image: '/img/team/member-03.jpg'
  },
  {
    name: 'Robert Legierski',
    role: 'Crypto Expert',
    image: '/img/team/member-04.jpg'
  },
  {
    name: 'Jarosław Lis',
    role: 'Senior Investigator',
    image: '/img/team/member-05.jpg'
  },
  {
    name: 'Adrian Lewandowski',
    role: 'Blockchain Specialist',
    image: '/img/team/member-06.jpg'
  },
  {
    name: 'Artur Rimas',
    role: 'Cybersecurity Expert',
    image: '/artur_jankowski.png'
  },
  {
    name: 'Żaneta Kamińska',
    role: 'Case Manager',
    image: '/zaneta_kaminska.png'
  },
  {
    name: 'Michał Bogacz',
    role: 'Recovery Consultant',
    image: '/img/team/member-07.jpg'
  },
  {
    name: 'Szymon Flis',
    role: 'Financial Investigator',
    image: '/img/team/member-08.jpg'
  }
];
